import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Table","TableHeader","TableRow","TableHead","TableBody","TableCell"] */ "/app/src/components/ui/table.tsx");
